import React, { useState, useEffect, useRef } from 'react';
import styles from './dropdown-with-select.module.scss';
import { RoundTriangle } from '../triangle/round-triangle';

interface DropdownWithSelectProps {
  options: string[];
  selected?: string;
  onChange: (selectedOption: string) => void;
}

export const DropdownWithSelect: React.FC<DropdownWithSelectProps> = ({
  options,
  selected,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(
    selected ? selected : options[0]
  );
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selected) {
      setSelectedOption(selected);
    }
  }, [selected]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className={styles.dropdown_container} ref={wrapperRef}>
      <div className={styles.input_wrapper}>
        <input
          type="text"
          value={selectedOption}
          readOnly
          onClick={handleInputClick}
          className={styles.dropdown_input}
        />
        <div className={styles.triangle_wrapper}>
          <RoundTriangle isRotated={isOpen} />
        </div>
      </div>

      <div
        className={`${styles.dropdown_list} ${
          isOpen ? styles.dropdown_list_open : ''
        }`}
      >
        {options.map((option) => (
          <div
            key={option}
            onClick={() => handleOptionClick(option)}
            className={`${styles.dropdown_item} ${
              option === selectedOption ? styles.dropdown_item_selected : ''
            }`}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};
